/// <amd-module name="CodeCoverage/AzureReposProvider/AzureReposProvider" />

import { GitVersionDescriptor, GitVersionOptions, GitVersionType, VersionControlRecursionType } from "CodeCoverage/Clients/VC/Contracts/Git";
import { getGitClient, IGitRestClient } from "CodeCoverage/Clients/VC/RestClient/Git";
import { IContentInfo } from "CodeCoverage/ViewCommon/Contracts/Common";
import { ISourceProvider } from "CodeCoverage/ViewCommon/Contracts/ISourceProvider";
import { publish } from "CodeCoverage/ViewCommon/Helpers";
import { IVssPageContext } from "VSS/Platform/Context";

export class AzureReposProvider implements ISourceProvider {
    private gitClient: IGitRestClient;
    private pageContext: IVssPageContext;

    public initialize(pageContext: IVssPageContext): void {
        // Initialize the git client.
        this.gitClient = getGitClient(pageContext);
        this.pageContext = pageContext;
    }

    public fetchContent(info: IContentInfo): Promise<string | null> {
        this.pushTelemetry(info, "fetchContent");
        const versionDescriptor: GitVersionDescriptor = {
            versionOptions: GitVersionOptions.None,
            version: info.version,
            versionType: GitVersionType.Commit
        } as GitVersionDescriptor;

        return this.gitClient.getItemText(
            info.repositoryId,
            info.path,
            info.projectId,
            undefined /* scopePath */,
            VersionControlRecursionType.None,
            false /* includeContentMetaData   */,
            false /* latestProcessedChange */,
            false /* download  */,
            versionDescriptor,
            true /* includeContent */,
            false /* resolveLfs */
        );
    }

    private pushTelemetry(info: IContentInfo, feature: string): void {
        const properties: { [id: string]: string } = {};
        properties["RepositoryId"] = info.repositoryId;
        properties["Version"] = info.version;
        publish(this.pageContext, feature, undefined, properties);
    }
}
